/**
 * External dependencies
 */
import React from 'react';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { get } from 'lodash';
/**
 * Internal dependencies
 */
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import { editLocation, saveLocation } from 'state/locations/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const LocationForm = ({ location, locationId, connectionLocations, ...props }) => {
    const handleOnChange = (name, value) => {
        props.editLocation(locationId, {
            [name]: value,
        });
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        props.beforeSubmit && props.beforeSubmit(location);

        try {
            let response = await props.saveLocation(locationId, location);
            props.afterSuccessfullSubmit && props.afterSuccessfullSubmit(response);
        } catch (error) {
            console.log(error);
        }

        props.afterSubmit && props.afterSubmit();
    };

    return (
        <form id='location-form' onSubmit={handleOnSubmit}>
            <Stack space='large'>
                <Box>
                    <FormLabel>Name:</FormLabel>
                    <FormTextInput
                        name='name'
                        value={get(location, 'name', '')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    />
                </Box>
                <Box>
                    <FormLabel>Location key:</FormLabel>
                    <FormTextInput
                        name='number'
                        value={get(location, 'number', '')}
                        onChange={(e) => handleOnChange('number', e.target.value)}
                    />
                </Box>
            </Stack>
        </form>
    );
};

export default connect(null, {
    editLocation,
    saveLocation,
})(LocationForm);
